import { ClientForm } from "@/components/admin/clients/ClientForm";

export default function CreateClient() {
  return (
    <div className="container mx-auto p-6 max-w-xl">
      <h1 className="text-3xl font-bold mb-6">Create New Client</h1>
      <ClientForm />
    </div>
  );
}
